import { icons } from "./icons";
import type { InputProps } from "./input";
import { Input } from "./input";
import { InputRightButton } from "./input-right-button";

type EmailInputProps = {
  reset: () => void;
} & InputProps;

export const EmailInput = ({ reset, ...props }: EmailInputProps) => {
  return <Input right={InputRightButton(!!props.error, reset, icons.XCircleIcon)} {...props} />;
};
